/** Binds `policy` to the document. Returns the unbind, which also resets the policy. */
export function bindLightDismiss(policy, options = {}) {
    const doc = options.document ?? (typeof document === "undefined" ? undefined : document);
    const win = options.window ?? (typeof window === "undefined" ? undefined : window);
    if (!doc)
        return () => policy.reset();
    const onDown = (event) => {
        const e = event;
        policy.pointerdown(e.target, {
            pointerId: e.pointerId ?? 0,
            isPrimary: e.isPrimary ?? true,
            button: e.button ?? 0,
        });
    };
    const onUp = (event) => {
        const e = event;
        policy.pointerup(e.target, e.pointerId ?? undefined);
    };
    const onClick = (event) => policy.click(event.target);
    const onCancel = (event) => policy.pointercancel(event.pointerId ?? 0);
    // An interaction whose end the page cannot observe is abandoned, not completed.
    const onAbandon = () => policy.reset();
    doc.addEventListener("pointerdown", onDown, true);
    doc.addEventListener("pointerup", onUp, true);
    doc.addEventListener("click", onClick, true);
    doc.addEventListener("pointercancel", onCancel, true);
    win?.addEventListener("blur", onAbandon);
    doc.addEventListener("visibilitychange", onAbandon);
    return () => {
        doc.removeEventListener("pointerdown", onDown, true);
        doc.removeEventListener("pointerup", onUp, true);
        doc.removeEventListener("click", onClick, true);
        doc.removeEventListener("pointercancel", onCancel, true);
        win?.removeEventListener("blur", onAbandon);
        doc.removeEventListener("visibilitychange", onAbandon);
        policy.reset();
    };
}
